{
  "heatNumber":"Heat number",
  "grade":"Grade",
  "begin":"Begin",
  "end":"End",
  "ladle":"Ladle",
  "weight":"Weight",
  "samples":"Samples",
  "buckets":"Buckets",
  "alloys":"Alloys",
  "delays":"Delays",
  "status":"Status",
  "temperature":"Temperature",
  "tapToTapTemperature":"TapToTap Temperature",
  "sourceName":"Source",
  "variables":"Variables"
}
